import React from 'react';

import OutputIcon from '@mui/icons-material/Output';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

type Props = {
  children: React.ReactNode;
};

/**
 * 成果物（Output）を示すボックス
 */
const WorkflowOutputBox: React.FC<Props> = ({ children }) => {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ px: 1.5, py: 1, bgcolor: 'action.hover', borderBottom: 1, borderColor: 'divider' }}
      >
        <OutputIcon sx={{ fontSize: 18, color: 'primary.main' }} />
        <Chip
          label="Output"
          size="small"
          color="primary"
          variant="outlined"
          sx={{ height: 20, fontSize: '0.65rem', fontWeight: 700 }}
        />
      </Stack>
      <Box sx={{ p: 1.5 }}>{children}</Box>
    </Box>
  );
};

export default WorkflowOutputBox;
